import { invariant } from '@/shared/utils/typeAssertions'
import { inject, provide } from 'vue'

import type { InjectionKey, Ref } from 'vue'

type WorkspaceContext = { workspaceId: Ref<string> }
export const WORKSPACE_CONTEXT_KEY: InjectionKey<WorkspaceContext> = Symbol('workspace')

export const provideWorkspaceContext = (workspaceId: Ref<string>) =>
  provide(WORKSPACE_CONTEXT_KEY, { workspaceId })

/**
 * Injects assumed to be provided workspace context.
 *
 * The application is structured in a way where most things are nested under a single workspace.
 * This composable is in charge of holding the id for that workspace.
 *
 * The injection context should be provided at the highest possible level of the application.
 */
export const useWorkspaceContext = () => {
  const workspaceContext = inject(WORKSPACE_CONTEXT_KEY)
  invariant(workspaceContext, 'Workspace context was not provided')
  return workspaceContext
}
